export class PropertyBase {
  public title: string;
  public value: any;
  public placeholder: any;
  constructor(data: any = {}) {}
}
